export default {
    baseUrl: 'https://lexination.com',
    dateFormat: 'MMM. DD, YYYY',
    dateLongFormat: 'MMM. DD, YYYY hh:mm a',
}